module.exports = __webpack_public_path__ + "img/agents_faults_fr-ch.4621d4e5.svg";